/** Values the Web fix-billing / retry flows send for offered-fix-billing tracking and retry APIs. */
export type WebUserFixBillingOfferViewedAt =
  | "web"
  | "redirectFromApp"
  | "drawDayWebFlow"
  | "admin";

/**
 * Maps the current URL query to `offerViewedAt` for Web fix-billing and retry payment calls.
 * - `drawTonight` (presence only) → `drawDayWebFlow` (draw-day web funnel).
 * - Else `offerViewedAt=admin` → `admin` (Admin User Detail fix-billing link; required for promo matrix override).
 * - Else `offerViewedAt=redirectFromApp` → `redirectFromApp`.
 * - Else → `web`.
 */
export const resolveOfferViewedAtFromSearchParams = (
  searchParams: URLSearchParams,
): WebUserFixBillingOfferViewedAt => {
  if (searchParams.has("drawTonight")) {
    return "drawDayWebFlow";
  }
  const offerViewedAtParam = searchParams.get("offerViewedAt");
  if (offerViewedAtParam === "admin") {
    return "admin";
  }
  if (offerViewedAtParam === "redirectFromApp") {
    return "redirectFromApp";
  }
  return "web";
};
